import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { Guid } from '@fitscovery/common/types';
import { PartnerPaymentMethodsResponse, GetPaymentMethodsResponse } from '../models';

import { Environment } from '@fitscovery/common/environments';
import { APP_ENVIRONMENT } from '../environment-injection';

@Injectable()
export class ApiPartnerPaymentsService {

  constructor(
    @Inject(APP_ENVIRONMENT) private env: Environment,
    private http: HttpClient,
  ) { }

  getPaymentMethods(): Observable<GetPaymentMethodsResponse> {
    return <Observable<GetPaymentMethodsResponse>>this.http.get(`${this.env.xendItApi.url}/payment-methods`);
  }

  getPartnerPaymentMethods(partnerId: Guid): Observable<PartnerPaymentMethodsResponse> {
    return <Observable<PartnerPaymentMethodsResponse>>this.http.get(`${this.env.xendItApi.url}/partners/${partnerId}/payment-methods`);
  }

  updatePartnerPaymentMethods(partnerId: Guid, paymentMethodIds: string[]): Observable<PartnerPaymentMethodsResponse> {
    return <Observable<PartnerPaymentMethodsResponse>>this.http.put(`${this.env.xendItApi.url}/partners/${partnerId}/payment-methods`, { paymentMethodIds });
  }

}
